<!--<svg *ngIf="!isIE11Browser" [ngClass]="[className]">
<use [attr.xlink:href]="'assets/NewJT7/img/sprite.svg#' + type"></use>
</svg>-->

@if (isIE11Browser && type !== 'sort-asc'  ) {
  <div [attr.data-loc]="type" [ngClass]="[className]" [innerHTML]="safeHTML"></div>
}


@if (isIE11Browser && type === 'sort-asc'  ) {
  <span [attr.data-loc]="type" [ngClass]="[className]" [innerHTML]="safeHTML">
  </span>
}

